let check_empty_field = (value) => {
    if (!value || (Array.isArray(value) && value.length == 0)){
        return "Field cannot be empty";
    } else{
        return "";
    }

}
let check_date_field = (value) => {
    const date = new Date(value);

    if (isNaN(date.getTime()) || !value) {
        return "Invalid date";
    } else {
        return "";
    }
}


let check_kra_pin = (value) => {
    if (value && value.length > 20) {
      return "Tax Pin must not exceed more than 20 characters.";
    }
    else{
        return "";
    }
}


let check_if_positive_number = (value) => {
    const parsedValue = parseInt(value);
    if(parsedValue <= 0){
        return "Amount must be greater than zero";
    } else {
        return "";
    }
}

let check_if_whole_number = (value) => {
    if(!Number.isInteger(parseFloat(value))){
        return "Amount must be positive integer (no decimals or fractions)";
    } else {
        return "";
    }
}

let check_if_number = (value) => {
    if (value && value.trim().match(/^0+.+|[^0-9\.]/g) ){
        return "Value must be a number (with no commas or leading zeros)."
    }else{
        return "";
    }
}

let check_mpesa_shortcodes_length = (value) => {
    if(!value){
        return "";
    }
    if (value && value.length < 5){
        return "Value must be atleast 5 digits long."
    } else if(value && value.length > 8){
        return "Value must be atmost 8 digits long."
    } else{
        return "";
    }
}

let check_valid_email = (value) => {
    if(!value){
        return "";
    }

    if(value.trim().length == 0){
        return "";
    }
    if (!value.trim().match(/[@]/g)){
        return "Email must contain @."
    }else{
        return "";
    }
}

let check_phone_number = (value) => {
    if(!value){
        return "";
    }

    if (!value.trim().match(/^(?=.*[0-9])[-+0-9]+$/)){
        return "Phone number must contains numbers (0-9), + and - only.";
    }else if(value.trim().includes('-') && value.trim().split("-")[1].length < 8){
        return "Phone number length must be atleast 8 numbers after the country code";
    }else{
        return "";
    }
}


let check_percentage = (value) => {
    if (parseFloat(value) < 0 || parseFloat(value) > 100){
        return "Value must be a number between 0 and 100."
    }else{
        return "";
    }
}

let check_penalty_day_of_month = (value) => {
    if(value === "0" || value === "" || value === null || !value){
        return "Day must be selected to automatically penalize."
    }else{
        return ""
    }
}

let clear_error_from_field = (value) => {
    return ""
}
export {
    check_empty_field,
    check_if_number,
    check_phone_number,
    check_valid_email,
    check_mpesa_shortcodes_length,
    check_percentage,
    check_kra_pin,
    check_if_positive_number,
    check_if_whole_number,
    check_penalty_day_of_month,
    clear_error_from_field,
    check_date_field
}
